


<div class="_dialog-content_" >
	<div class="_offer-name">{{data.offer.name}}</div>
<mat-tab-group class="wiz-tabs hide-headers" [selectedIndex]="wizardStep()" [dynamicHeight]="true">
	<mat-tab>
		<div class="_body">
			<div class="_title">
				{{ title() }}
			</div>
		</div>
		<div class="_d_actions">
			@if (enableEdit) {
				<button type="button" mat-flat-button color="primary" class="rounded" (mousedown)="gotoExisting()"
						style="min-width: 120px">{{ 'TD.edit_existing' | translate }}
				</button>
				<button type="button" mat-flat-button color="accent" class="rounded" style="flex-grow: 1" (mousedown)="addNew()">
					{{'TD.add_new_offer' | translate}}
				</button>
			} @else {
				<button type="button" mat-button color="accent" class="rounded" (mousedown)="close()" >
					{{'Cancel' | translate}}
				</button>
				<button type="button" mat-flat-button color="accent" class="rounded" style="flex-grow: 1" (mousedown)="addNew()">
					{{'TD.add_another_same' | translate}}
				</button>
			}

		</div>
	</mat-tab>
	<mat-tab>
		<div class="_title-alt">
			{{title()}}
		</div>
		<div class="scroll-y" style="max-height: calc(100vh - 300px)">
			@for (offer of data.existingOffers; track offer._id) {
			<div class="basket-row">
				<div class="_header d-flex justify-content-between">
					<div class="_actions">
						@if (offer._enableEdit) {
							<button type="button" (mousedown)="editOffer(offer)" [disabled]="offer.isLoyaltyOffer" class="mr-3" style="transform: scale(1.1);">
								<mat-icon svgIcon="edit"></mat-icon>
							</button>
						}
						<button type="button" (mousedown)="deleteOffer(offer, false)"
								[class._inactive]="offer.quantity == 1">
							<mat-icon [svgIcon]="offer.quantity == 1 ? 'trash' : 'minus'"></mat-icon>
						</button>
						<div class="_counter text-highlight">
							{{ offer.quantity }}
						</div>
						<button type="button" (mousedown)="duplicateOffer(offer)" [disabled]="offer.isLoyaltyOffer">
							<mat-icon svgIcon="plus"></mat-icon>
						</button>
					</div>
					<div class="_price text-highlight">
						{{ offer.quantity * offer.total | lcurrency }}
					</div>
				</div>
				<div class="_summary">
					@if (offer._item && offer._item.summary) {
						<div class="_summary-row">
							<div>{{ offer._item.summary.text }}</div>
						</div>
					}
					@if (offer.selectionSummary?.length) {
						@for (group of offer.selectionSummary | filterBy:{_visible: true}; track $index; ) {
							<div class="_summary-row">
								<b>{{ group.name }}:</b>
								@for (item of group.items; track $index; ) {
									<div>
										<div>
											@if (item.count > 1) {
												<span>{{ item.count }}*</span>
											}
											{{ item.name || 'missing' }}
											@if (item._item.total > 0) {
												<span
													class="inline m-near-xs">+{{ item._item.total | lcurrency }}</span>
											}
										</div>
										@if (item.$wasEdit && item._item.summary) {
											<small class="block mb-1">{{ item._item.summary.text }}</small>
										}
									</div>
								}
							</div>
						}
					}
					@if (offer.offerRemrks) {
						<div class="_summary-row">
							<i>*{{ offer.offerRemrks }}</i>
						</div>
					}
				</div>
			</div>
		}</div>
		<div class="_or"><span>{{ 'TD.or_add_new' | translate }}</span></div>

		<div class="_d_actions mt-4">
			<button type="button" mat-button color="accent" class="rounded" (mousedown)="close()" >
				{{'Cancel' | translate}}
			</button>
			<button type="button" mat-flat-button color="primary" class="rounded flex-grow-1"  (mousedown)="addNew()" >
				{{'TD.add_new_offer' | translate}}
			</button>
		</div>

	</mat-tab>

</mat-tab-group>
</div>





